import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import Header from "../../components/UI/Header/Header";
import DraftForms from "../../components/Forms/DraftForms/DraftForms";
import axios from "axios";
import classes from "./draftslist.css";
import { backendBaseUri } from "../../uri";

class DraftsList extends Component {
    componentDidMount() {
        axios
            .get(`${backendBaseUri}/drafts`, {
                headers: {
                    "x-auth": localStorage.getItem("token"),
                },
            })
            .then((res) => {
                this.props.onFormListLoad(res.data.drafts);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    handleClickDraftedConsent(id) {
        const { consentForms } = this.props;
        let formIdToView = consentForms[id]._id;

        axios
            .get(`${backendBaseUri}/drafts/${formIdToView}`, {
                headers: {
                    "x-auth": localStorage.getItem("token"),
                },
            })
            .then((res) => {
                this.props.onDisplayForm(res.data.draft);
                this.props.history.push(`/form/${id}`);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    render() {
        const { consentForms } = this.props;

        return (
            <div>
                <header>
                    <Header />
                </header>
                <div className={classes.MainContainer}>
                    <div className={classes.ListSection}>
                        <h2>Saved Forms</h2>
                        {consentForms.length > 0 && (
                            <DraftForms
                                forms={consentForms}
                                handleClickDraftedConsent={this.handleClickDraftedConsent.bind(
                                    this,
                                )}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        consentForms: state.formBuilder.consentForms,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onFormListLoad: (forms) => dispatch(actions.fetchForms(forms)),
        onDisplayForm: (form) => dispatch(actions.fetchForm(form)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DraftsList);



// WEBPACK FOOTER //
// ./src/containers/DraftsList/DraftsList.js